import { ChangeDetectorRef, Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslatorlangService } from '../../../../shared/services/translatorlang.service';
import { CommonService } from '../../../../shared/services/common.service';
import { Router } from '@angular/router';
import { API_ENDPOINTS } from '../../../../shared/utils/const';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from '../../../../shared/services/api.service';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';



@Component({
  selector: 'app-eoi-exhibition',
  templateUrl: './eoi-exhibition.component.html',
  styleUrl: './eoi-exhibition.component.css'
})
export class EOIExhibitionComponent {
  FrontfileErrors: { typeError: boolean; sizeError: boolean } = { typeError: false, sizeError: false };
  frontbookFile: File | null = null;
  casteCert: File | null = null;
  maxSizeInMB = 5;
  selectedPhotos: File[] = [];
  udyamFile!: File;
  casteFile!: File;
  videoFile!: File;
  photoFile!: File;
  photoFiles: File[] = [];
  currentYear = new Date().getFullYear();
  today = new Date();
  districtList: any[] = [];
  socialCategoryList: any[] = [];
  organizationTypeList: any[] = [];

  form = this.fb.group({

    registrationType: ['MSME', Validators.required],
    
    //  msmEName: ['', Validators.required], 
     //change by hardik on 04-05-2026 add new field for msme name and artisan name and remove pattern validation from udyam/artisan card no field


  msmeName: this.fb.control<string>('', [
    Validators.required,
    Validators.pattern(/^[A-Za-z0-9\s]+$/) // optional example
  ]),

  artisanName: this.fb.control<string>('', [
    Validators.required
  ]),


    aadhaarNumber: ['', [
      Validators.required,
      Validators.pattern(/^[2-9][0-9]{11}$/)
    ]],

    organizationTypeID: [null, Validators.required],
    yearOfEstablishment: [
      '',
      [
        Validators.required,
        this.yearValidator(this.currentYear)
      ]
    ],

      //change by hardik on 04-05-2026 add new field for msme name and artisan name and remove pattern validation from udyam/artisan card no field
//chnage start

    //     udyamOrArtisanCardNo: this.fb.control<string>(
    //   '',
    //   [
   
    //   ]
    // ),

    // udyamOrArtisanCardNo: this.fb.control<string>(
    //   '',
    //   [
    //     Validators.required,
    //      Validators.pattern(/^UDYAM-MH-\d{2}-\d{7}$/)
    //   ]
    // ),

  //     udyamNumber: this.fb.control<string>('UDYAM-MH', [
  //   Validators.required,
  //   Validators.pattern(/^UDYAM-MH-\d{2}-\d{7}$/)
  // ]),

    udyamNumber: new FormControl<string | null>('UDYAM-MH-', [
      Validators.required,
      Validators.pattern(this.commonService.udyamNumber),
    ]),

  artisanNumber: this.fb.control<string>('', [
    Validators.required
  ]),

//chnage END






     industrySector: ['', Validators.required],


  industrySectorSelect: ['', Validators.required],
  industrySectorOther: [''],

    socialCategoryID: [null, Validators.required],
    gender: ['', Validators.required],
    registeredAddress: ['', Validators.required],
    districtID: [null, Validators.required],
    pinCode: ['', [
      Validators.required,
      Validators.pattern(/^4[0-9]{5}$/)
    ]],

    contactPersonName: ['', Validators.required],
    designation: ['', Validators.required],

    mobileNumber: ['', [
      Validators.required,
      Validators.pattern(/^[6-9][0-9]{9}$/)
    ]],

    alternateMobileNumber: ['', [
  
      Validators.pattern(/^[6-9][0-9]{9}$/)
    ]],

    emailAddress: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]],

    productServiceDescription: ['', Validators.required],
    uniqueSellingPoints: ['', Validators.required],
    targetMarket: ['', Validators.required],

    participatedInExhibition: ['', Validators.required],
    exhibitionDetails: ['', Validators.required],
    preferredExhibitionType: ['', Validators.required],

    requireGovernmentSupport: ['', Validators.required],
    specificAssistanceRequired: ['', Validators.required],

    authorizedSignatoryName: ['', Validators.required],
    authorizedSignatoryDesignation: ['', Validators.required],
    declarationDate: [null, [Validators.required, this.noFutureDateValidator]],
    objectiveID: [null, Validators.required],


    udyamCert: [null],

    casteCert: new FormControl(null),
    video: [null],
    photos: [null],
    VideoFile: [null, Validators.required],
    PhotoFile: [null, Validators.required],
    UdyamFile: [null, Validators.required],
    CasteFile: [null, Validators.required],
    declarationAccepted: [false, Validators.requiredTrue],
  });


  get registrationType() {
  return this.form.get('registrationType')?.value;
}
  translate: any = {};
  currentLanguage: any;
  constructor(private fb: FormBuilder, private translateService: TranslatorlangService, private cd: ChangeDetectorRef,
    private apiService: ApiService,
    private toastr: ToastrService,
    public commonService: CommonService,
    private router: Router,
  ) {
    const savedLanguage = sessionStorage.getItem('selectedLanguage') || 'en';  // Default to English
    this.currentLanguage = savedLanguage;
    this.loadLanguage(this.currentLanguage);
  }

  ngOnInit(): void {
    this.getDropDownList();
    this.switchLanguage(this.currentLanguage);

    

  }

  ngAfterViewInit() {
    this.translateService.LanguageChangeData.subscribe((data) => {
      this.currentLanguage = data;
    });
  }

  switchLanguage(lang: string): void {
    if (lang !== this.currentLanguage) {
      this.loadLanguage(lang);
      sessionStorage.setItem('selectedLanguage', lang);  // Save language in localStorage
    }
  }

  loadLanguage(lang: string): void {
    this.translateService.getTranslation(lang).subscribe((data: any) => {
      this.translate = data;
      this.cd.detectChanges();
      this.currentLanguage = lang;
      this.translateService.updateData(this.translate);
      this.translateService.updateLanguageData(this.currentLanguage);
    });
  }

  getDropDownList() {
    this.apiService.getRequest(API_ENDPOINTS.getdistrictlistbystate).subscribe((result) => {
      this.districtList = result.data;

      console.log('District List:', this.districtList);
    });

    this.apiService.getRequest(API_ENDPOINTS.getSocialCategory).subscribe((result) => {
      this.socialCategoryList = result.data;
      console.log('Social Category List:', this.socialCategoryList);  
    });

    this.apiService.getRequest(API_ENDPOINTS.getOrganizationType).subscribe((result) => {
      this.organizationTypeList = result.data;  
      console.log('Organization Type List:', this.organizationTypeList);
    }); 
  }

  onFrontFileSelected(event: Event): void {

    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length) {
      this.casteCert = input.files[0];

      // Reset file errors
      this.FrontfileErrors = { typeError: false, sizeError: false };

      // Check file type (only images like jpg, png)
      const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      if (!validTypes.includes(this.casteCert.type)) {
        this.FrontfileErrors.typeError = true;
      }

      // Check file size (maxSizeInMB limit)
      const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024; // Convert 2 MB to Bytes
      if (this.casteCert.size > maxSizeInBytes) {
        this.FrontfileErrors.sizeError = true;
      }

      // Set file name in form if validation passes
      if (!this.FrontfileErrors.typeError && !this.FrontfileErrors.sizeError) {
        // this.form.patchValue({
        //   casteCert: this.casteCert.name
        // });
        this.form.get('frontbookFile')?.markAsTouched();
        this.form.get('frontbookFile')?.markAsDirty();

        const file = this.frontbookFile;
        if (file) {

          const reader = new FileReader();
          reader.onload = (e: any) => {
            // this.frontimageUrl = e.target.result; // Show selected file as a preview
          };
          reader.readAsDataURL(file);
        }

      } else {
        this.form.patchValue({
          casteCert: null
        });
      }
    }
  }

  getObjectiveText(value?: string | number | null): string {
  if (!value) return '-';

  switch (String(value)) {
    case '1':
      return this.translate?.OBJECTIVE?.PROMO || 'Product Promotion';
    case '2':
      return this.translate?.OBJECTIVE?.NET || 'Networking';
    case '3':
      return this.translate?.OBJECTIVE?.BUSINESS || 'Business Expansion';
    case '4':
      return this.translate?.OBJECTIVE?.EXPORT || 'Export Opportunities';
    default:
      return '-';
  }
}
  noFutureDateValidator(control: AbstractControl) {
    if (!control.value) return null;

    const selectedDate = new Date(control.value);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return selectedDate > today ? { futureDate: true } : null;
  }

  allowAddressChars(event: KeyboardEvent) {
    const input = event.target as HTMLTextAreaElement;
    const key = event.key;

    const allowedPattern = /^[a-zA-Z0-9 .,()\/&:;'\"!?-]$/;

    // Allow control keys (Backspace, Delete, Arrow keys, Tab)
    if (
      key === 'Backspace' ||
      key === 'Delete' ||
      key === 'Tab' ||
      key === 'ArrowLeft' ||
      key === 'ArrowRight'
    ) {
      return;
    }

    if (!allowedPattern.test(key)) {
      event.preventDefault();
      return;
    }

    if (key === ' ' && input.selectionStart === 0) {
      event.preventDefault();
      return;
    }

    const value = input.value;
    const cursorPos = input.selectionStart ?? value.length;

    // Check previous character
    if (
      key === ' ' &&
      cursorPos > 0 &&
      value[cursorPos - 1] === ' '
    ) {
      event.preventDefault();
      return;
    }
  }



  getInvalidFields(form: FormGroup) {
  const invalidFields: string[] = [];

  Object.keys(form.controls).forEach(key => {
    const control = form.get(key);

    if (control && control.invalid) {
      invalidFields.push(key);
      console.log(`❌ ${key} is invalid`, control.errors);
    }
  });

  return invalidFields;
}

//   onSubmit() {
//  this.onRegistrationTypeChange(); 
//   this.onIndustrySectorChange();

//    if (this.form.invalid) {
//   this.form.markAllAsTouched();
//   this.getInvalidFields(this.form);
//   return;
// }

//     const formData = new FormData();

//     Object.keys(this.form.controls).forEach(key => {
//       if (['UdyamFile', 'CasteFile', 'VideoFile', 'PhotoFile'].includes(key)) {
//         return;
//       }

//       const value = this.form.get(key)?.value;

//       if (value !== null && value !== undefined && value !== '') {
//         formData.append(key, value);
//       }
//     });

//     const declarationDate = this.form.get('declarationDate')?.value;
//     if (declarationDate) {
//       const formattedDate = new Date(declarationDate)
//         .toISOString()
//         .substring(0, 10); // yyyy-MM-dd

//       formData.set('declarationDate', formattedDate);
//     }

//     if (this.udyamFile) {
//       formData.append('UdyamFile', this.udyamFile);
//     }

//     if (this.casteFile) {
//       formData.append('CasteFile', this.casteFile);
//     }

//     if (this.videoFile) {
//       formData.append('VideoFile', this.videoFile);
//     }

//     if (this.photoFile) {
//       formData.append('PhotoFile', this.photoFile);
//     }


//   this.apiService.postRequest(API_ENDPOINTS.addExhibitionRegistrationForm, formData).subscribe({
//   next: (res: any) => {
//     if (res?.status === true) {
// const {
//   organizationTypeID,
//   socialCategoryID,
//   districtID,
//   targetMarket,
//   participatedInExhibition,
//   objectiveID,
//   requireGovernmentSupport,
//   gender,
//   registrationType,
//   industrySectorSelect,
//   industrySectorOther,
//   industrySector,
//   declarationDate,
//   ...restFormData
// } = this.form.value;

// const pdfData = {

//   ...restFormData,

//   // ✅ Declaration Date Format
//   declarationDate: declarationDate
//     ? new Date(declarationDate).toLocaleDateString('en-GB')
//     : '',

//   // ✅ Organization Type
//   organizationType: this.getValueById(
//     this.organizationTypeList,
//     organizationTypeID,
//     'organizationTypeId',
//     'organizationTypeName'
//   ),

//   // ✅ Social Category
//   socialCategory: this.getValueById(
//     this.socialCategoryList,
//     socialCategoryID,
//     'socialCategoryId',
//     'socialCategoryName'
//   ),

//   // ✅ District
//   district: this.getValueById(
//     this.districtList,
//     districtID,
//     'districtId',
//     'districtName'
//   ),

//   // ✅ Target Market
//   targetMarket: this.getTargetMarketText(targetMarket),

//   // ✅ Participated In Exhibition
//   participatedInExhibition:
//     this.getYesNoText(participatedInExhibition),

//   // ✅ Government Support
//   requireGovernmentSupport:
//     this.getYesNoText(requireGovernmentSupport),

//   // ✅ Gender Mapping
//   gender:
//     gender === 'M'
//       ? 'Male'
//       : gender === 'F'
//       ? 'Female'
//       : gender === 'O'
//       ? 'Other'
//       : '',

//   // ✅ Industry Sector Logic
//   industrySector:
//     registrationType === 'MSME'
//       ? (
//           industrySectorSelect === 'Other'
//             ? industrySectorOther
//             : industrySectorSelect
//         )
//       : industrySector,

//   // ✅ Objective Mapping
//   objective: this.getObjectiveText(objectiveID)

// };


//       // ✅ use mapped data
//       const pdfBlob = this.generatePdf(pdfData, res.Data);

//       const file = new File(
//         [pdfBlob],
//         `${res.applicationId}_EOI_Exhibition_Form.pdf`,
//         { type: 'application/pdf' }
//       );

//       const formDownloadData = new FormData();
//       formDownloadData.append('DownloadEOIExhibitionFile', file);
//       formDownloadData.append('ApplicationId', res.applicationId);

//       this.apiService.postRequest(
//         API_ENDPOINTS.addExhibitionRegistrationDownloadForm,
//         formDownloadData
//       ).subscribe(() => {
//         this.toastr.success(`Form submitted successfully. Application ID: ${res.applicationId}`);
//       });

//       this.router.navigate(['/login']);

//     } else {
//       this.toastr.error('Submission failed.');
//     }
//   },
//   error: (err) => {
//     console.error(err);
//     this.toastr.error('Something went wrong. Please try again.');
//   }
// });
//   }

onSubmit() {

  this.onRegistrationTypeChange();

  this.onIndustrySectorChange();

  if (this.form.invalid) {

    this.form.markAllAsTouched();

    this.getInvalidFields(this.form);

    return;

  }

  const formData = new FormData();

  // ✅ Append Form Values
  Object.keys(this.form.controls).forEach(key => {

    if (['UdyamFile', 'CasteFile', 'VideoFile', 'PhotoFile'].includes(key)) {
      return;
    }

    const value = this.form.get(key)?.value;

    if (value !== null && value !== undefined && value !== '') {
      formData.append(key, value);
    }

  });

  // ✅ Format Declaration Date
  const declarationDate = this.form.get('declarationDate')?.value;

  if (declarationDate) {

    const formattedDate = new Date(declarationDate)
      .toISOString()
      .substring(0, 10);

    formData.set('declarationDate', formattedDate);

  }

  // ✅ Append Files
  if (this.udyamFile) {
    formData.append('UdyamFile', this.udyamFile);
  }

  if (this.casteFile) {
    formData.append('CasteFile', this.casteFile);
  }

  if (this.videoFile) {
    formData.append('VideoFile', this.videoFile);
  }

  if (this.photoFile) {
    formData.append('PhotoFile', this.photoFile);
  }

  // ✅ Submit API
  this.apiService.postRequest(
    API_ENDPOINTS.addExhibitionRegistrationForm,
    formData
  ).subscribe({

    next: (res: any) => {

      if (res?.status === true) {

        // ✅ Destructure Form Values
        const {

          organizationTypeID,
          socialCategoryID,
          districtID,
          targetMarket,
          participatedInExhibition,
          objectiveID,
          requireGovernmentSupport,
          gender,
          registrationType,
          industrySectorSelect,
          industrySectorOther,
          industrySector,
          declarationDate,
          ...restFormData

        } = this.form.value;

        // ✅ Prepare PDF Data
        const pdfData = {

          ...restFormData,

          registrationType,

          // ✅ Declaration Date
          declarationDate: declarationDate
            ? new Date(declarationDate).toLocaleDateString('en-GB')
            : '',

          // ✅ Organization Type
          organizationType: this.getValueById(
            this.organizationTypeList,
            organizationTypeID,
            'organizationTypeId',
            'organizationTypeName'
          ),

          // ✅ Social Category
          socialCategory: this.getValueById(
            this.socialCategoryList,
            socialCategoryID,
            'socialCategoryId',
            'socialCategoryName'
          ),

          // ✅ District
          district: this.getValueById(
            this.districtList,
            districtID,
            'districtId',
            'districtName'
          ),

          // ✅ Target Market
          targetMarket:
            targetMarket === 'D'
              ? 'Domestic'
              : targetMarket === 'I'
              ? 'International'
              : targetMarket === 'B'
              ? 'Both'
              : '-',

          // ✅ Participated In Exhibition
          participatedInExhibition:
            participatedInExhibition === 'Y'
              ? 'Yes'
              : participatedInExhibition === 'N'
              ? 'No'
              : '-',

          // ✅ Government Support
          requireGovernmentSupport:
            requireGovernmentSupport === 'Y'
              ? 'Yes'
              : requireGovernmentSupport === 'N'
              ? 'No'
              : '-',

          // ✅ Gender
          gender:
            gender === 'M'
              ? 'Male'
              : gender === 'F'
              ? 'Female'
              : gender === 'O'
              ? 'Other'
              : '',

          // ✅ Industry Sector Logic
          industrySector:
            registrationType === 'MSME'
              ? (
                  industrySectorSelect === 'Other'
                    ? industrySectorOther
                    : industrySectorSelect
                )
              : industrySector,

          // ✅ Objective Mapping
objective:
  String(objectiveID) === '1'
    ? 'Product Promotion'
    : String(objectiveID) === '2'
    ? 'Networking'
    : String(objectiveID) === '3'
    ? 'Business Expansion'
    : String(objectiveID) === '4'
    ? 'Export Opportunities'
    : '-'
        };

        // ✅ Generate PDF
        const pdfBlob = this.generatePdf(pdfData, res.Data);

        const file = new File(
          [pdfBlob],
          `${res.applicationId}_EOI_Exhibition_Form.pdf`,
          { type: 'application/pdf' }
        );

        // ✅ Upload Generated PDF
        const formDownloadData = new FormData();

        formDownloadData.append(
          'DownloadEOIExhibitionFile',
          file
        );

        formDownloadData.append(
          'ApplicationId',
          res.applicationId
        );

        this.apiService.postRequest(
          API_ENDPOINTS.addExhibitionRegistrationDownloadForm,
          formDownloadData
        ).subscribe(() => {

          this.toastr.success(
            `Form submitted successfully. Application ID: ${res.applicationId}`
          );

        });

        // ✅ Redirect
        this.router.navigate(['/login']);

      } else {

        this.toastr.error('Submission failed.');

      }

    },

    error: (err) => {

      console.error(err);

      this.toastr.error(
        'Something went wrong. Please try again.'
      );

    }

  });

}

getValueById(list: any[], id: any, idKey: string, nameKey: string): string {
  return list?.find(x => x[idKey] == id)?.[nameKey]?.trim() || '-';
}
  generatePdf(formData: any, enterpriseCode: string | null = null): Blob {
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4',
    });

    const margin = 10;
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    // Border
    doc.setDrawColor(0);
    doc.setLineWidth(1);
    doc.rect(margin, margin, pageWidth - 2 * margin, pageHeight - 2 * margin);

    // Logos
    const logo1 = 'assets/Images/RAMP_LOGO.jpg';
    const logo2 = 'assets/Images/logo_icon.png';
    doc.addImage(logo1, 'JPEG', 15, 15, 30, 30);
    doc.addImage(logo2, 'PNG', pageWidth - 45, 15, 30, 30);

    // Titles
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(16);
    doc.setTextColor(197, 41, 42);
    doc.text(
      'Maharashtra Small Scale Industries Development Corporation Ltd.',
      pageWidth / 2,
      25,
      { align: 'center' }
    );

    doc.setFontSize(11);
    doc.setTextColor(0, 0, 0);
    doc.text('A Government Of Maharashtra Undertaking', pageWidth / 2, 32, {
      align: 'center',
    });

    doc.setFontSize(10);
    doc.text('CIN No. U74999MH1962SGC012501', pageWidth / 2, 38, {
      align: 'center',
    });

    // Line
    const lineY = 55;
    doc.line(margin + 5, lineY, pageWidth - margin - 5, lineY);

    // Subtitle
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(14);
    doc.setTextColor(0, 86, 179);
    doc.text('EOI Exhibition Registration Details', pageWidth / 2, lineY + 10, {
      align: 'center',
    });

    // --- Helper function for key formatting ---
    function formatKey(key: string): string {
      return key
        // Insert space before capital letters
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        // Handle consecutive capitals (like ID, GST, PAN)
        .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
        // Capitalize first letter of each word
        .replace(/\b\w/g, (char) => char.toUpperCase())
        .trim();
    }

    // --- Clean formData ---
    const cleaned: Record<string, any> = {};

    if (enterpriseCode) {
      // Assign to a new key, "EnterpriseCode", for display
      cleaned['EnterpriseCode'] = enterpriseCode;
    }

    for (const key in formData) {
      if (
        formData.hasOwnProperty(key) &&
        !key.endsWith('File') &&
        !key.endsWith('Path') &&
        key !== 'navigationId' &&
        key !== 'DistrictId'
      ) {
        let value = formData[key];
        if (typeof value === 'boolean') value = value ? 'Yes' : 'No';
        if (!value) value = 'N/A';
        cleaned[key] = value;
      }
    }

    // --- Convert to 2-column rows ---
    const rows: any[] = [];
    const entries = Object.entries(cleaned);

    for (let i = 0; i < entries.length; i += 2) {
      const col1Key = entries[i] ? formatKey(entries[i][0]) : '';
      const col1Val = entries[i] ? `${entries[i][1]}` : '';
      const col2Key = entries[i + 1] ? formatKey(entries[i + 1][0]) : '';
      const col2Val = entries[i + 1] ? `${entries[i + 1][1]}` : '';

      rows.push([
        { content: col1Key, styles: { fontStyle: 'bold' } },
        { content: col1Val, styles: { fontStyle: 'normal' } },
        { content: col2Key, styles: { fontStyle: 'bold' } },
        { content: col2Val, styles: { fontStyle: 'normal' } },
      ]);
    }

    // --- Table ---
    autoTable(doc, {
      startY: lineY + 20,
      head: [['', '', '', '']],
      body: rows,
      styles: { fontSize: 10, cellPadding: 3 },
      theme: 'grid',
      headStyles: { fillColor: [197, 41, 42], textColor: 255 },
      margin: { left: margin, right: margin },
    });

    // Save PDF
    const enterpriseName = cleaned['EnterpriseName'] || 'EOI_Exhibition_Registration';
    doc.save(`${enterpriseName}_Form_Data.pdf`);

    // 2. CRITICAL CHANGE: Return the PDF content as a Blob
    const pdfBlob = doc.output('blob');

    return pdfBlob;
  }

getTargetMarketText(value?: string | null): string {
  switch (value) {
    case 'D': return this.translate?.MARKET?.DOM || 'Domestic';
    case 'I': return this.translate?.MARKET?.INT || 'International';
    case 'B': return this.translate?.MARKET?.BOTH || 'Both';
    default: return '-';
  }
}

getYesNoText(value?: string | null): string {
  if (!value) return '-';

  switch (value) {
    case 'Y':
      return this.translate?.YES || 'Yes';
    case 'N':
      return this.translate?.NO || 'No';
    default:
      return '-';
  }
}
  onPhotoChange(event: any) {
    const files = event.target.files;

    if (!files || files.length === 0) return;

    // Identify by accept attribute
    const accept = event.target.accept;

    if (accept === 'video/*') {
      this.videoFile = files[0];
    }
    else if (!this.photoFile) {
      this.photoFile = files[0];
    }
    else {
      // single files (udyam / caste)
      if (!this.udyamFile) this.udyamFile = files[0];
      else this.casteFile = files[0];
    }
  }


  videoDurationError: boolean = false;

  onVideoChange(event: any) {
    const file = event.target.files[0];

    if (!file) return;

    const video = document.createElement('video');
    video.preload = 'metadata';

    video.onloadedmetadata = () => {
      window.URL.revokeObjectURL(video.src);

      const duration = video.duration; // seconds

      if (duration < 10 || duration > 20) {
        this.videoDurationError = true;
        this.form.get('VideoFile')?.setErrors({ invalidDuration: true });
      } else {
        this.videoDurationError = false;
        this.form.get('VideoFile')?.setErrors(null);
      }
    };

    video.src = URL.createObjectURL(file);
  }

  onlyNumbersWithFour(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;

    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
      return;
    }

    if (input.value.length === 0 && event.key !== '4') {
      event.preventDefault();
    }
  }

  onlyMobileNumber(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;

    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
      return;
    }

    if (input.value.length === 0 && !/[6-9]/.test(event.key)) {
      event.preventDefault();
    }
  }

  onFirstNameInput(event: Event): void {
    const input = event.target as HTMLInputElement;

    let value = input.value;

    // 1. Allow only letters and space
    value = value.replace(/[^a-zA-Z ]/g, '');

    // 2. Remove leading spaces
    value = value.replace(/^\s+/g, '');

    // 3. Allow ONLY one space between words
    value = value.replace(/\s{2,}/g, ' ');

    // 4. Capitalize first letter of each word
    value = value
      .toLowerCase()
      .replace(/\b\w/g, char => char.toUpperCase());

    input.value = value;
    this.form.get('msmeName')?.setValue(value, { emitEvent: false });
  }

  onContactPersonInput(event: Event): void {
    const input = event.target as HTMLInputElement;

    let value = input.value;

    // 1. Allow only letters and space
    value = value.replace(/[^a-zA-Z ]/g, '');

    // 2. Remove leading spaces
    value = value.replace(/^\s+/g, '');

    // 3. Allow ONLY one space between words
    value = value.replace(/\s{2,}/g, ' ');

    // 4. Capitalize first letter of each word
    value = value
      .toLowerCase()
      .replace(/\b\w/g, char => char.toUpperCase());

    input.value = value;
    this.form.get('contactPersonName')?.setValue(value, { emitEvent: false });
  }

  onDesignationNameInput(event: Event): void {
    const input = event.target as HTMLInputElement;

    let value = input.value;

    // 1. Allow only letters and space
    value = value.replace(/[^a-zA-Z ]/g, '');

    // 2. Remove leading spaces
    value = value.replace(/^\s+/g, '');

    // 3. Allow ONLY one space between words
    value = value.replace(/\s{2,}/g, ' ');

    // 4. Capitalize first letter of each word
    value = value
      .toLowerCase()
      .replace(/\b\w/g, char => char.toUpperCase());

    input.value = value;
    this.form.get('designation')?.setValue(value, { emitEvent: false });
  }

  onAuthorizedSignatoryNameInput(event: Event): void {
    const input = event.target as HTMLInputElement;

    let value = input.value;

    // 1. Allow only letters and space
    value = value.replace(/[^a-zA-Z ]/g, '');

    // 2. Remove leading spaces
    value = value.replace(/^\s+/g, '');

    // 3. Allow ONLY one space between words
    value = value.replace(/\s{2,}/g, ' ');

    // 4. Capitalize first letter of each word
    value = value
      .toLowerCase()
      .replace(/\b\w/g, char => char.toUpperCase());

    input.value = value;
    this.form.get('authorizedSignatoryName')?.setValue(value, { emitEvent: false });
  }

  onAuthorizedSignatoryDesignationInput(event: Event): void {
    const input = event.target as HTMLInputElement;

    let value = input.value;

    // 1. Allow only letters and space
    value = value.replace(/[^a-zA-Z ]/g, '');

    // 2. Remove leading spaces
    value = value.replace(/^\s+/g, '');

    // 3. Allow ONLY one space between words
    value = value.replace(/\s{2,}/g, ' ');

    // 4. Capitalize first letter of each word
    value = value
      .toLowerCase()
      .replace(/\b\w/g, char => char.toUpperCase());

    input.value = value;
    this.form.get('authorizedSignatoryDesignation')?.setValue(value, { emitEvent: false });
  }

  allowOnlyFourDigits(event: KeyboardEvent) {
    const inputChar = event.key;

    // Allow control keys (Backspace, Delete, Arrow keys, Tab)
    if (
      inputChar === 'Backspace' ||
      inputChar === 'Delete' ||
      inputChar === 'Tab' ||
      inputChar === 'ArrowLeft' ||
      inputChar === 'ArrowRight'
    ) {
      return;
    }

    // Allow digits only
    if (!/^[0-9]$/.test(inputChar)) {
      event.preventDefault();
      return;
    }

    const input = event.target as HTMLInputElement;

    // Prevent more than 4 digits
    if (input.value.length >= 4) {
      event.preventDefault();
    }
  }

  futureYearValidator() {
    return (control: any) => {
      if (!control.value) return null;

      return +control.value > this.currentYear
        ? { futureYear: true }
        : null;
    };
  }

  yearValidator(currentYear: number) {
    return (control: AbstractControl) => {
      const value = control.value;

      if (!value) {
        return null;
      }

      const year = Number(value);

      // ❌ Not exactly 4 digits
      if (!/^\d{4}$/.test(value)) {
        return { invalidYear: true };
      }

      // ❌ 0000 or less than 1900
      if (year < 1900) {
        return { invalidYear: true };
      }

      // ❌ Future year
      if (year > currentYear) {
        return { futureYear: true };
      }

      return null;
    };
  }

  limitYearLength(event: Event) {
    const input = event.target as HTMLInputElement;

    input.value = input.value.replace(/\D/g, '').slice(0, 4);

    this.form.get('yearOfEstablishment')?.setValue(input.value, {
      emitEvent: false
    });
  }

  aadhaarKeyPress(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;

    // Allow backspace
    if (charCode === 8) {
      return;
    }

    // Allow only digits (0–9)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return;
    }

    const input = event.target as HTMLInputElement;
    const value = input.value;

    // Max length = 12
    if (value.length >= 12) {
      event.preventDefault();
      return;
    }

    // First digit must be 2–9
    if (value.length === 0) {
      const firstDigit = Number(String.fromCharCode(charCode));
      if (firstDigit < 2 || firstDigit > 9) {
        event.preventDefault();
        return;
      }
    }
  }

  allowEnglishAndNumbers(event: KeyboardEvent) {
    const charCode = event.key;

    const regex = /^[A-Za-z0-9 ]$/;

    if (!regex.test(charCode)) {
      event.preventDefault();
    }
  }

  allowEnglishPaste(event: any) {
    const pastedText = event.clipboardData.getData('text');
    const regex = /^[A-Za-z0-9 ]+$/;

    if (!regex.test(pastedText)) {
      event.preventDefault();
    }
  }


onRegistrationTypeChange() {
  const type = this.form.get('registrationType')?.value;

  const msmeName = this.form.get('msmeName');
  const artisanName = this.form.get('artisanName');
  const artisanNumber = this.form.get('artisanNumber');
  const udyamNumber = this.form.get('udyamNumber');
  const udyamFile = this.form.get('UdyamFile');

  if (type === 'MSME') {

    // ✅ Enable MSME controls
    msmeName?.enable();
    udyamNumber?.enable();


    // ❌ Disable Artisan controls
    artisanName?.disable();
    artisanNumber?.disable();

    // ✅ Set validators
    msmeName?.setValidators([
      Validators.required,
      Validators.pattern(/^[A-Za-z0-9\s]+$/)
    ]);
    udyamNumber?.setValidators([Validators.required]);



    udyamNumber?.setValidators([
      Validators.required,
      Validators.pattern(this.commonService.udyamNumber)
    ]);
    udyamFile?.setValidators([Validators.required]);

    // ❌ Clear Artisan validators
    artisanName?.clearValidators();
    artisanNumber?.clearValidators();

    // Reset artisan values
    artisanName?.reset();
    artisanNumber?.reset();
       if (!udyamNumber?.value) {
      udyamNumber?.setValue('UDYAM-MH-');
    }

  } else {

    // ✅ Enable Artisan controls
    artisanName?.enable();
    artisanNumber?.enable();

    // ❌ Disable MSME controls
    msmeName?.disable();
    udyamNumber?.disable();
    

    // ✅ Set validators
    artisanName?.setValidators([Validators.required]);
    artisanNumber?.setValidators([Validators.required]);
 udyamFile?.setValidators([Validators.required]);
    // ❌ Clear MSME validators
    msmeName?.clearValidators();
    udyamNumber?.clearValidators();


    // Reset MSME values
    msmeName?.reset();
    udyamNumber?.reset();

  }

  // 🔁 Update all controls
  [
    msmeName,
    artisanName,
    artisanNumber,
    udyamNumber,
    udyamFile
  ].forEach(control => {
    control?.updateValueAndValidity();
  });

  // 🔥 FINAL IMPORTANT LINE
  this.form.updateValueAndValidity();
}

onIndustryChange() {
  const sector = this.form.get('industrySectorSelect')?.value;
  const otherControl = this.form.get('industrySectorOther');

  if (sector === 'Other') {
    otherControl?.setValidators([
      Validators.required,
      Validators.maxLength(100)
    ]);
  } else {
    otherControl?.clearValidators();
    otherControl?.reset();
  }

  otherControl?.updateValueAndValidity();
}



setConditionalValidators(type: string) {
  const msmeName = this.form.get('msmeName');
  const artisanName = this.form.get('artisanName');
  const artisanNumber = this.form.get('artisanNumber');
  const udyamNumber = this.form.get('udyamNumber');
  const udyamFile = this.form.get('UdyamFile');

  if (type === 'MSME') {
    // MSME required
    msmeName?.setValidators([
      Validators.required,
      Validators.pattern(/^[A-Za-z0-9\s]+$/)
    ]);
    udyamNumber?.setValidators([Validators.required]);
    udyamFile?.setValidators([Validators.required]);

    // Remove artisan validators
    artisanName?.clearValidators();
    artisanNumber?.clearValidators();

  } else {
    // Artisan required
    artisanName?.setValidators([Validators.required]);
    artisanNumber?.setValidators([Validators.required]);

    // Remove MSME validators
    msmeName?.clearValidators();
    udyamNumber?.clearValidators();
    udyamFile?.clearValidators();
  }

  // IMPORTANT: update validity
  msmeName?.updateValueAndValidity();
  artisanName?.updateValueAndValidity();
  artisanNumber?.updateValueAndValidity();
  udyamNumber?.updateValueAndValidity();
  udyamFile?.updateValueAndValidity();
}

onIndustrySectorChange() {

  const type = this.form.get('registrationType')?.value;

  const industrySector = this.form.get('industrySector');
  const industrySectorSelect = this.form.get('industrySectorSelect');
  const industrySectorOther = this.form.get('industrySectorOther');

  const selectedValue = industrySectorSelect?.value;

  if (type === 'MSME') {

    // ✅ MSME logic
    industrySector?.clearValidators();
    industrySector?.setErrors(null);
    industrySector?.reset();
    industrySector?.disable();

    industrySectorSelect?.setValidators([Validators.required]);
    industrySectorSelect?.enable();

    // 👉 handle "Other"
    if (selectedValue === 'Other') {
      industrySectorOther?.setValidators([Validators.required]);
      industrySectorOther?.enable();
    } else {
      industrySectorOther?.clearValidators();
      industrySectorOther?.setErrors(null);
      industrySectorOther?.reset();
      industrySectorOther?.disable();
    }

  } else {

    // ✅ NON-MSME logic
    industrySector?.setValidators([Validators.required]);
    industrySector?.enable();

    industrySectorSelect?.clearValidators();
    industrySectorSelect?.setErrors(null);
    industrySectorSelect?.reset();
    industrySectorSelect?.disable();

    industrySectorOther?.clearValidators();
    industrySectorOther?.setErrors(null);
    industrySectorOther?.reset();
    industrySectorOther?.disable();
  }

  // 🔁 update all
  [
    industrySector,
    industrySectorSelect,
    industrySectorOther
  ].forEach(control => {
    control?.updateValueAndValidity();
  });

  this.form.updateValueAndValidity();
}



  onUdyamInput(event: any) {

    
  let value = event.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');


    if (!value || value.trim() === '') {
    this.form.get('udyamNumber')?.setValue('UDYAM-MH-', { emitEvent: false });
    return;
  }

  if (value.length > 5) value = value.slice(0, 5) + '-' + value.slice(5);
  if (value.length > 8) value = value.slice(0, 8) + '-' + value.slice(8);
  if (value.length > 11) value = value.slice(0, 11) + '-' + value.slice(11);

  this.form.get('udyamNumber')?.setValue(value, { emitEvent: false });
}
}
